import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const [version, setVersion] = useState('');

  fetch('/.well-known/nmw-metadata').then(r => r.json()).then((metadata) => {
      setVersion('v' + metadata.majorVersion + '.' + metadata.minorVersion)
  }).catch(() => {
      setVersion('v0.0')
  })

  return (
    
      <div className="footer">
        <p>
          © {new Date().getFullYear()}{" "}
          <a href="mailto:info@mynext.id">MyNextDPP</a> {version} | All rights reserved |
          {/*<span
            className="clickable"
            onClick={() => {
              navigate("/termsOfService");
            }}
          >
            {" "}
            Terms of service{" "}
          </span>
          |
          <span
            className="clickable"
            onClick={() => {
              navigate("/privacyPolicy");
            }}
          >
            {" "}
            Privacy policy
          </span>*/}
        </p>
      </div>
    
  );
};

export default Footer;
